module.exports = __webpack_public_path__ + "Step5_Header_new.9acadcd3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Step5_Header_new.png
// module id = uzWm
// module chunks = 0